module.exports = __webpack_public_path__ + "img/exam_evidence.a603a0eb.png";